export const GainsightEventNameLabels = {
  patientBroadcastLists: 'Pt Broadcast Lists',
  PtSettings: 'Pt Settings',
  patientsList: 'Patients List',
  'Patient Data': 'Patient Data',
  'Patient Video': 'Patient Video',
  'Analytics Patient Video': 'Patient Video',
  'Analytics Patient Data': 'Patient Data',
  automatedMessages: 'Automated Messages',
  'Create Provider Broadcast List': 'Create List',
  'MessageTemplates/Dynamic/CreateMessageTemplate': 'Create Template Dynamic',
  'scheduledMessages/Admin': 'Sched Msg - Admin',
  'scheduledMessages/Automated': 'Sched Msg - Automated',
  'scheduledMessages/Personal': 'Sched Msg - Personal',
  scheduledMessages: 'Sched Msg - Personal',
  'MessageTemplates/General/CreateMessageTemplate': 'Create Template General',
  virtualWaitingRoom: 'Create New Waiting Room',
  'Create personal Message Template': 'Create Template - Personal',
  'Create general Message Template': 'Create Template - General',
  'Create aar_variables Message Template': 'Create Template - Dynamic',
  'Create Patient Broadcast List': 'Create Patient Broadcast',
  'Create automated Schedule Message Template': 'Create Schedule Message Template - Automated',
  'Create personal Schedule Message Template': 'Create Schedule Message Template - Personal',
  'Create all Schedule Message Template': 'Create Schedule Message Template - All',
  'Customer Support': 'Customer Support',
  customLabeling: 'Custom Labeling',
  Forums: 'Forums',
  Insights: 'Insights',
  'Login Password': 'Password',
  'Login Username': 'Username',
  Messages: 'Messenger',
  messageTemplates: 'Msg Templates - Personal',
  'messageTemplates/Personal': 'Msg Templates - Personal',
  'messageTemplates/Dynamic': 'Msg Templates - Dynamic',
  'messageTemplates/General': 'Msg Templates - General',
  'Org Settings': 'Org Settings',
  Organizations: 'Organizations',
  'Patient Network User Settings': 'Pt Network Profile Settings',
  'Profile Settings': 'Profile Settings',
  'Roles&Teams': 'Roles & Teams',
  Roles: 'Roles',
  Transactions: 'Transactions',
  Trends: 'Trends',
  Users: 'Users',
  VirtualWaitingRoom: 'Virtual Waiting Room',
  'VoIP Calling': 'VoIP Calling',
  'Patient Context': 'Patient Context',
  'Patient Audit': 'Patient Audit',
  'Clinical Workflow': 'Clinical Workflow',
};

export const GainsightParentSettingsEventNameLabels = {
  Analytics: 'Analytics',
  Messages: 'Inbox | Messenger',
  Roles: 'Roles',
  'Roles & Teams': 'Roles & Teams',
  Settings: 'Admin + Settings',
  'Patient Network Messenger': 'Pt Inbox | Pt Inbox',
  'Patient Settings': 'Pt Settings',
  'Virtual Waiting': 'Pt Inbox | Virtual Waiting',
  'Broadcast Lists': 'Broadcast Lists',
  'Patient Directory': 'Inbox | Patient Directory',
};
